module.exports = __webpack_public_path__ + "static/media/motorcycle.03d9aa67.svg";